type Props = {
  stack: string[];
  size?: 'sm' | 'xs';
  limit?: number;
};

export function StackTags({ stack, size = 'sm', limit }: Props) {
  const visible = typeof limit === 'number' ? stack.slice(0, limit) : stack;
  const remaining = typeof limit === 'number' ? Math.max(0, stack.length - limit) : 0;
  const isXs = size === 'xs';
  return (
    <div className="flex flex-wrap gap-1.5">
      {visible.map((tech) => (
        <span
          key={tech}
          className="font-mono stack-tag transition-colors"
          style={{
            fontSize: isXs ? 9 : 10,
            fontWeight: 500,
            padding: isXs ? '2px 7px' : '3px 10px',
            borderRadius: 6,
            border: '1px solid var(--border)',
            color: 'var(--text-muted)',
            background: 'transparent',
            letterSpacing: '0.03em',
          }}
        >
          {tech}
        </span>
      ))}
      {remaining > 0 && (
        <span
          className="font-mono"
          style={{
            fontSize: isXs ? 9 : 10,
            fontWeight: 600,
            padding: isXs ? '2px 7px' : '3px 10px',
            color: 'var(--text-caption)',
          }}
        >
          +{remaining}
        </span>
      )}
    </div>
  );
}
